import { render, staticRenderFns } from "./newsPageHeader.vue?vue&type=template&id=31091814&scoped=true"
import script from "./newsPageHeader.vue?vue&type=script&lang=js"
export * from "./newsPageHeader.vue?vue&type=script&lang=js"
import style0 from "./newsPageHeader.vue?vue&type=style&index=0&id=31091814&prod&lang=scss&scoped=true"
import style1 from "./newsPageHeader.vue?vue&type=style&index=1&id=31091814&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31091814",
  null
  
)

export default component.exports